import moment from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { Moment } from 'moment';
import { DepositBankAccount } from './deposit-bank-account';
import { Organization } from './organization';
import { Transaction } from './transactions/transaction';

export class LockboxDepositNotice
{
    id: number;
    organizationId: number;
    managementId: number;
    depositBankAccountId: number;
    depositDate: Moment;
    numberOfChecks: number;
    amount: number;
    createdAt: Moment;
    updatedAt: Moment;
    deletedAt: Moment;
    originalRecord: string;

    organization: Organization;
    depositBankAccount: DepositBankAccount;
    transaction: Transaction;

    constructor(depositNotice: any) {
        if (depositNotice.id) {
            this.id = depositNotice.id;
        }

        if (depositNotice.organizationId) {
            this.organizationId = depositNotice.organizationId;
            if (depositNotice.organization) {
                this.organization = new Organization(depositNotice.organization);
            }
        }

        if (depositNotice.managementId) {
            this.managementId = depositNotice.managementId;
        }

        if (depositNotice.depositBankAccountId) {
            this.depositBankAccountId = depositNotice.depositBankAccountId;
            if (depositNotice.depositBankAccount) {
                this.depositBankAccount = new DepositBankAccount(depositNotice.depositBankAccount);
            }
        }

        if (depositNotice.transaction) {
            this.transaction = new Transaction(depositNotice.transaction);
        }

        if (depositNotice.hasOwnProperty('numberOfChecks')) {
            this.numberOfChecks = depositNotice.numberOfChecks;
        }

        if (depositNotice.hasOwnProperty('amount')) {
            this.amount = depositNotice.amount;
        }

        const timezone = LegFiJwtService.getTimezone();
        if (depositNotice.depositDate) {
            this.depositDate = moment.utc(depositNotice.depositDate, 'YYYY-MM-DD hh:mm:ss').tz(timezone); //This will just be a date- make sure it parses correctly
        }
        if (depositNotice.createdAt) {
            this.createdAt = moment.utc(depositNotice.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (depositNotice.updatedAt) {
            this.updatedAt = moment.utc(depositNotice.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (depositNotice.deletedAt) {
            this.deletedAt = moment.utc(depositNotice.deletedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

    }
}
